import React from 'react'
import ListLayout from '../../../components/layout/main/ListLayout'
import { PageCard } from '../../../styles/CommonStyles'
import { ScaleLoader } from 'react-spinners'
import FixerSettings from '../../../components/main/setting/fixer/FixerSettings'
import { useGetFixerSettings } from '../../../core/services/react-query/setting/fixer'
import FixerSettingsList from '../../../components/main/setting/fixer/FixerSettingsList'

const Fixer = () => {

    const { data: fixerSettings, isLoading } = useGetFixerSettings()

    return (
        <ListLayout>
            <PageCard>
                {
                    isLoading ?
                        <div className='col-span-1 sm:col-span-2 lg:col-span-4 w-full flex justify-center'>
                            <ScaleLoader
                                color={'#ffc800'}
                                height={18}
                                width={4}
                            />
                        </div> :
                        <>

                            <FixerSettings fixerSettings={fixerSettings} />
                            <FixerSettingsList fixerSettings={fixerSettings} />
                        </>
                }
            </PageCard>
        </ListLayout>
    )
}

export default Fixer